import { default as studentsRoutes } from '../modules/students/routes';
import { default as schoolsRoutes } from '../modules/schools/routes';
import { default as tutorCourses } from '../modules/tutors/routes';
import { default as searchRoutes } from '../modules/search/routes';
import { default as homeRoutes } from '../modules/home/routes';
import { default as teachersRoutes } from '../modules/teachers/routes';
import { default as personaRoutes } from '../modules/personas/routes';
import { default as coursesRoutes } from '../modules/courses/routes';
import { default as setupRoutes } from '../modules/setup/routes';
import { default as adminRoutes } from '../modules/admin/routes';


const routes = [
  ...homeRoutes,
  ...studentsRoutes,
  ...schoolsRoutes,
  ...adminRoutes,
  ...tutorCourses,
  ...searchRoutes,
  ...teachersRoutes,
  ...personaRoutes,
  ...coursesRoutes,
  ...setupRoutes,

  

];


export default routes;